import { DateWithTimezones, MapStopActionType, MapStopType, PointData } from '../../../../common/models';
import { TransportMode } from '../../../../common/constants';

export class ShipmentSpecialFreightToGpsPointModel implements PointData {
  actions: MapStopActionType[];
  address: string;
  dateTime: DateWithTimezones;
  extId: string;
  latitude: number;
  longitude: number;
  name: string;
  viewType: MapStopType;
  sortIndex: string;
}

export class ShipmentSpecialFreightMapData {
  gpsPoints: ShipmentSpecialFreightToGpsPointModel[];
  transportMode: TransportMode;
}
